import { useState } from 'react';
import { faqs } from '@/mocks/news';

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <p className="flex items-center gap-2 text-sm font-bold tracking-widest text-accent-700">
              <span className="h-px w-8 bg-accent-500" /> 常见问题
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              关于阅读与投稿，你可能想问
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              如果你还有其他疑问，欢迎通过页面底部的编辑部邮箱与我们联系，我们会认真回复每一条来信。
            </p>
            <a
              href="mailto:hello@chiguamag.example"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-mail-send-line" aria-hidden="true" /> 联系编辑部
            </a>
          </div>

          <div className="space-y-3 lg:col-span-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? 'border-primary-300' : 'border-background-200'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {f.q}
                    </h3>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                      }`}
                    >
                      <i
                        className={`ri-add-line transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}
                        aria-hidden="true"
                      />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-200 px-5 py-4">
                      <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}